import { useTranslation } from "react-i18next";
import { match } from "ts-pattern";
import { apiErrorTag } from "@/lib/api-error";

/**
 * A refused product write in Dutch, by the error's tag (`packages/contract/src/product.ts` names
 * them per procedure). Anything unexpected is the general "saving failed".
 */
export function useProductErrorMessage() {
	const { t } = useTranslation("product");
	const { t: tCommon } = useTranslation();
	return (error: unknown): string =>
		match(apiErrorTag(error))
			.with("SlugTaken", () => t("error.slugTaken"))
			.with("SkuTaken", () => t("error.skuTaken"))
			.with("EanTaken", () => t("error.eanTaken"))
			.with("OptionNameTaken", () => t("error.optionNameTaken"))
			.with("OptionValueNameTaken", () => t("error.valueNameTaken"))
			.with("TooManyVariants", () => t("error.tooManyVariants"))
			.with("LastVariant", () => t("error.lastVariant"))
			.with("CombinationTaken", () => t("error.combinationTaken"))
			.with("ProductChanged", () => t("error.changed"))
			.with("ProductNotFound", () => t("error.notFound"))
			.with("BundleWithoutOptions", () => t("error.bundleWithoutOptions"))
			.with("UnknownCategory", () => t("error.unknownCategory"))
			.with("UnknownAttributeValue", () => t("error.unknownAttributeValue"))
			.with("UnknownHolder", () => t("error.unknownHolder"))
			.with("TwoSizes", () => t("error.twoSizes"))
			.with("ProductArchived", () => t("error.archived"))
			.otherwise(() => tCommon("form.failed"));
}
